import React, { PureComponent } from 'react';

// Import widgets being used in this component
import NumberWidgetContainer from './dashboard/NumberWidgetContainer';
import GraphWidgetContainer from './dashboard/GraphWidgetContainer';
import LiquidGauge from './dashboard/LiquidGauge';

import { CircleSpinner } from 'react-spinners-kit';

import firebase from 'firebase/app';

import moment from 'moment';

// Add in styles
import '../styles/App.css';

class App extends PureComponent {
	constructor() {
		super();

		//REFACTOR THIS STATE MANAGEMENT *IMPLEMENT REDUX*
		this.state = {
			sensorId: '',
			timestamp: null,
			distance: 0,
			tankVol: undefined,
			hspace: undefined,
			height: undefined,
			period: 10,
			percent: 0,
			volume: 0,
			isLoading: true,
			waterUsage: undefined,
			waterHarvest: undefined,
			waterRate: undefined,
			waterStats: 0,
			daysRemaining: undefined,
			isRealtimeGraphLoaded: false,
			histLabel: [],
			data: [{}],
			histLabelTank: [],
			dataTank: [{}],
			activeGraph: 'consumptionGraph',
		};
	}

	async componentWillMount() {
		//Getting the config tank props from the url path
		//(create a "login" page that gets only the ID and search for the config properties on firebase)
		let sensorId = this.props.sensorId;
		this.setState({ sensorId: this.props.sensorId });

		let period = 7;

		let hspace, height, volume, fineadj;

		/////////////////////////FIREBASE//BEGIN/////////////////////////////////////////////////////////
		//Get tank Props to calculate Volume and percentage
		await firebase
			.database()
			.ref('/sensors/' + sensorId + '/props/tank')
			.on('value', snap => {
				let item = snap.val();

				//TO FIX
				//Converting it from Metric to Imperial
				//This data is coming from the database as Imperial, but the frontEnd is working in metric system(cm)
				hspace = item.hspace / 0.393701;
				height = item.height / 0.393701;
				volume = item.capacity;
				fineadj = item.fineadjustment / 0.393701;

				this.setState({ hspace, height, volume, period, fineadj });
			});

		//Get Distance and Timestamp from sensor last log
		await firebase
			.database()
			.ref('/sensors/' + sensorId + '/logs/')
			.limitToLast(1)
			.on('child_added', snap => {
				let item = snap.val();
				this.setState({ distance: item.distance, timestamp: item.timestamp });
				this.getPercentage();
				this.getTankVolume();
			});

		//Firebase Water Consumption Data /> NumberWidgetContainer
		/*const waterUsage = */
		await firebase
			.database()
			.ref('/sensors/' + sensorId + '/data/twiceAdayLogs')
			.limitToLast(period * 8)
			.on('value', async snap => {
				let waterFlag = 0;
				let waterUsage = 0,
					waterHarvest = 0;

				snap.forEach(element => {
					let item = element.val();

					//Managing water consumption by checking if the water data is increasing or decreasing
					if (waterFlag === 0) {
						waterFlag = item.tankCurrentStatus;
					} else if (waterFlag > item.tankCurrentStatus) {
						waterUsage += waterFlag - item.tankCurrentStatus;
						waterFlag = item.tankCurrentStatus;
					} else {
						waterHarvest += item.tankCurrentStatus - waterFlag;
						waterFlag = item.tankCurrentStatus;
					}
				});

				this.setState({
					waterHarvest: waterHarvest.toFixed(0),
					waterUsage: waterUsage.toFixed(0),
					waterRate: (waterUsage / period).toFixed(2),
				});

				//Remaining days for the tank at the current usage Rate
				this.daysRemaining();

				//function that set state loading to false // ADD Melhorar essa função...
				this.loaderState();
			});

		//Firebase Water Consumption Data /> NumberWidgetContainer
		/*const waterUsage = */
		// % variable on daily usage
		// await firebase
		//   .database()
		//   .ref("/sensors/" + sensorId + "/data/twiceAdayLogs")
		//   .limitToLast(12) //about 1.5 day
		//   .on("value", async snap => {
		//     let waterFlagDay = 0;
		//     let waterUsageDailyRate = 0
		//     let waterHarvestDaily = 0;

		//     snap.forEach(element => {
		//       let item = element.val();

		//       //Managing water consumption by checking if the water data is increasing or decreasing
		//       if (waterFlagDay === 0) {
		//         waterFlagDay = item.tankCurrentStatus;
		//       } else if (waterFlagDay > item.tankCurrentStatus) {
		//         waterUsageDailyRate += waterFlagDay - item.tankCurrentStatus;
		//         waterFlagDay = item.tankCurrentStatus;
		//       } else {
		//         waterHarvestDaily += item.tankCurrentStatus - waterFlagDay;
		//         waterFlagDay = item.tankCurrentStatus;
		//       }
		//     });

		//     this.setState({
		//       waterStats: waterUsageDailyRate / 1.5, /*Rate for 1.5Days*/
		//       waterStatsUsageDaily: waterHarvestDaily
		//     });
		//   });

		//GraphWidget Data from Firebase
		/*const addToGraph = */
		await firebase
			.database()
			.ref('/sensors/' + sensorId + '/data/dailyUsage')
			.limitToLast(7) //7 days
			//Using value gets all the data at once, making it easier to work syncrhonously
			.on('value', snap => {
				let histLabel = [];
				let data = [
					{
						type: 'bar',
						label: 'Water Consumed (gl)',
						usage: [],
						harvesting: [],
					},
				];

				//iterate over the snap to get the data to the graph widget
				snap.forEach(element => {
					let item = element.val();
					histLabel.push(moment(item.tankTimestamp).format('MM/DD'));
					data[0].usage.push(item.waterUsage.toFixed(2));
					data[0].harvesting.push(item.waterHarvest.toFixed(2));
				});

				this.setState({
					histLabel: histLabel,
					data: data,
				});
			});

		await firebase
			.database()
			.ref('/sensors/' + sensorId + '/data/weeklyLogs7d')
			.limitToLast(48) //12 should represent 3 months
			//Using value gets all the data at once, making it easier to work syncrhonously
			.on('value', snap => {
				let histLabel = [];
				let data = [{ type: 'line', label: 'Tank Status (%)', usage: [] }];

				//iterate over the snap to get the data to the graph widget
				snap.forEach(element => {
					let item = element.val();
					histLabel.push(moment(item.tankTimestamp).format('MM/DD'));
					data[0].usage.push(item.tankPercentage);
				});

				this.setState({
					histLabelTank: histLabel,
					dataTank: data,
				});
			});
	} ////////////////////////////////FIREBASE//END///////////////////////////////////////////

	daysRemaining = () => {
		let volume = this.state.tankVol;
		let rate = this.state.waterRate;

		let daysRemaining = parseInt(volume / rate);

		this.setState({ daysRemaining });
	};

	async changeActiveGraph() {
		const { sensorId } = this.state;
		if (this.state.activeGraph === 'tankGraph') {
			this.setState({ activeGraph: 'consumptionGraph' });
		} else if (this.state.activeGraph === 'consumptionGraph') {
			await firebase
				.database()
				.ref('/sensors/' + sensorId + '/logs')
				.limitToLast(192) //2 days of previous logs
				//Using value gets all the data at once, making it easier to work syncrhonously
				.on('value', snap => {
					let histRealTimeLabel = [];
					let dataRealTime = [{ type: 'line', label: 'Tank Status (%)', usage: [] }];
					//iterate over the snap to get the data to the graph widget
					snap.forEach(element => {
						let item = element.val();
						histRealTimeLabel.push(moment(item.timestamp).format('dd hh:mm a'));
						dataRealTime[0].usage.push(this.getPercentageFromRealTimeGraph(item.distance));
					});
					this.setState({
						histLabelRealTimeTank: histRealTimeLabel,
						dataRealTimeTank: dataRealTime,
						isRealtimeGraphLoaded: true,
					});
				});
			this.setState({ activeGraph: 'RealTimeTankGraph' });
		} else if (this.state.activeGraph === 'RealTimeTankGraph') {
			this.setState({ activeGraph: 'tankGraph' });
		}
	}

	getTime = () => {
		return moment(this.state.timestamp).format('h:mm:ss a, MMM Do');
	};

	loaderState = () => {
		this.setState({ isLoading: false });
	};

	getPercentage = () => {
		let totalH = this.state.height - this.state.hspace;
		let waterLevel = totalH - (this.state.distance + this.state.fineadj - 20); //20cm
		let percent = ((waterLevel / totalH) * 100).toFixed(2);
		this.setState({ percent: percent });
		return percent;
	};

	getPercentageFromRealTimeGraph = distance => {
		let totalH = this.state.height - this.state.hspace;
		let waterLevel = totalH - (distance + this.state.fineadj - 20); //20cm
		let percent = ((waterLevel / totalH) * 100).toFixed(2);
		this.setState({ percent: percent });
		return percent;
	};

	getTankVolume = () => {
		let percent = this.getPercentage();
		let tankVol = ((percent / 100) * this.state.volume).toFixed(0);
		this.setState({ tankVol: tankVol });
	};

	render() {
		return this.state.isLoading ? (
			<div className="spinner">
				<CircleSpinner size={50} color="#2196F3" loading={this.state.spinner} />
			</div>
		) : (
			<div className="App">
				{/* Add Widgets to display */}
				<LiquidGauge value={this.state.percent > 100 ? 100 : this.state.percent} />
				{/* <NumberWidgetContainer value={this.state.percent} heading="Available water supply (%)" loading={this.state.isLoading} /> */}
				<NumberWidgetContainer
					value={this.state.tankVol}
					sub={this.state.volume}
					heading="Gallons Available"
					loading={this.state.isLoading}
				/>
				<NumberWidgetContainer
					value={this.state.waterRate + ' gal'}
					heading={'Daily Water Usage Rate'}
					loading={this.state.isLoading}
					// stats={((((this.state.waterStats / this.state.waterRate)-1)*100)).toFixed(2)}
				/>
				<NumberWidgetContainer
					value={this.state.waterUsage + ' gal'}
					heading={'Water Usage (' + this.state.period + ' days)'}
					loading={this.state.isLoading}
				/>
				<NumberWidgetContainer
					value={this.state.waterHarvest + ' gal'}
					heading={'Water Collected (' + this.state.period + ' days)'}
					loading={this.state.isLoading}
				/>
				{this.state.activeGraph === 'consumptionGraph' && (
					<GraphWidgetContainer
						value={this.state.data}
						label={this.state.histLabel}
						heading="Consumed Water vs Collected"
						colspan={2}
						rowspan={2}
						loading={this.state.isLoading}
						changeGraph={() => this.changeActiveGraph()}
					/>
				)}
				{(this.state.activeGraph === 'RealTimeTankGraph' && this.state.isRealtimeGraphLoaded) && (
					<GraphWidgetContainer
						value={this.state.dataRealTimeTank}
						label={this.state.histLabelRealTimeTank}
						heading="Tank Real Time Status (%)"
						colspan={2}
						rowspan={2}
						loading={this.state.isLoading}
						changeGraph={() => this.changeActiveGraph()}
					/>
				)}
        {(this.state.activeGraph === 'RealTimeTankGraph' && !this.state.isRealtimeGraphLoaded) && (
					<div style={{margin: '100 100'}}>
						<CircleSpinner size={50} color="#2196F3" loading={this.state.spinner} />
					</div>
				)}
				{this.state.activeGraph === 'tankGraph' && (
					<GraphWidgetContainer
						value={this.state.dataTank}
						label={this.state.histLabelTank}
						heading="Tank Status Over Time(%)"
						colspan={2}
						rowspan={2}
						loading={this.state.isLoading}
						changeGraph={() => this.changeActiveGraph()}
					/>
				)}
				<NumberWidgetContainer
					value={this.state.daysRemaining ? this.state.daysRemaining : 'n/a'}
					heading={'Remaining Days'}
					loading={this.state.isLoading}
				/>
				<NumberWidgetContainer
					value={
						this.state.timestamp ? (Date.now() - 3600000 < this.state.timestamp ? 'ON' : 'OFF') : undefined
					}
					sub={this.state.timestamp ? 'last reading ' + this.getTime() : ' '}
					heading="Sensor Status"
					loading={false}
					icon={true}
				/>
				<NumberWidgetContainer
					value={
						this.state.distance
							? ((this.state.distance + +this.state.fineadj) * 0.393701).toFixed(2)
							: undefined
					}
					heading="Sensor distance from water(in)"
					loading={this.state.isLoading}
				/>
			</div>
		);
	}
}
export default App;
